import axios from 'axios'
import i18next from 'i18next'
import { countryList } from '../../../../static/countries'
import { countriesWithParcelShopsInDBList } from '../../../../static/countriesWithParcelShops'

export const  i18nIsoCountriesVar = require("i18n-iso-countries");
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/en.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/de.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/pl.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/da.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/fr.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/nl.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/es.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/hu.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/sk.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/sl.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/cs.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/fi.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/pt.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/it.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/hr.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/sv.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/et.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/lt.json"));
i18nIsoCountriesVar.registerLocale(require("i18n-iso-countries/langs/lv.json"));


export const SET_IDENTIFIER = 'SET_IDENTIFIER'
export const SET_CONFIG = 'SET_CONFIG'
export const SET_FEATURES = 'SET_FEATURES'
export const SET_FROM_COUNTRIES = 'SET_FROM_COUNTRIES'
export const SET_RETURN_REASONS = 'SET_RETURN_REASONS'


const state = {
  identifier: undefined,
  config: {},
  features: {},
  fromCountries: [],
  returnReasons:[]
}

/**
 * Sort object properties by value (only own properties will be sorted).
 * @param {object} obj object that needs to be sorted
 * @returns {object} obj object with sorted properties
 */
 function sortProperties(obj) {
   var sortable = [];

   for(var key in obj) {
     if(obj.hasOwnProperty(key)) {
       sortable.push([key, obj[key]]);
     }
   }

  let sortedCountries = sortable.sort((a, b) => a[1].localeCompare(b[1]))

  let reduedSortedCountries = sortedCountries.reduce(
    (acc, country) => {
      acc[country[0]] = country[1]
      return acc
    },
    {}
  )

   return reduedSortedCountries;
 }

const getters = {
  brandName: state => {
    if (!state.config.brandName) {
      state.config.brandName = '[BRANDNAME]'
    }
    return state.config.brandName
  },
  heroTextColor: state => {
    if (!state.config.heroTextColor) {
      state.config.heroTextColor = ''
    }
    return state.config.heroTextColor
  },
  fieldTextColor: state => {
    if (!state.config.fieldTextColor) {
      state.config.fieldTextColor = ''
    }
    return state.config.fieldTextColor
  },
  buttonColor: state => {
    if (!state.config.buttonColor) {
      state.config.buttonColor = ''
    }
    return state.config.buttonColor
  },
  buttonTextColor: state => {
    if (!state.config.buttonTextColor) {
      state.config.buttonTextColor = ''
    }
    return state.config.buttonTextColor
  },
  pageTextColor: state => {
    if (!state.config.pageTextColor) {
      state.config.pageTextColor = ''
    }
    return state.config.pageTextColor
  },
  parcelShopInfoBackgroundColor: state => {
    if (!state.config.parcelShopInfoBackgroundColor) {
      state.config.parcelShopInfoBackgroundColor = ''
    }
    return state.config.parcelShopInfoBackgroundColor
  },
  suppressConfirmationMail: state => {
    return state.config.suppressConfirmationMail;
  },
  averageWeightGram: state => {
    return state.config.averageWeightGram;
  },

  countries: (state, getters, rootState) => {
    let reducedCountries =  state.fromCountries.reduce(
      (acc, country) => {
        acc[country.alpha2] = i18nIsoCountriesVar.getName(
          country.alpha2,
          rootState.lang.currentLanguage
        ) || country.name
        return acc
      },
      {}
    )

    let sortedCountries = sortProperties(reducedCountries)

    return sortedCountries;
  },

  returnHungary: (state, getters, rootState) => {
    return countryList.reduce(
      (acc, country) => {
        if(country.alpha2 === 'HU') {
          acc[country.alpha2] = i18nIsoCountriesVar.getName(
           country.alpha2,
           rootState.lang.currentLanguage
          ) || country.name
        }
        return acc
      },
      {}
    )
  },

  allCountries: (state, getters, rootState) => {
    return countryList.reduce(
      (acc, country) => {
        acc[country.alpha2] = i18nIsoCountriesVar.getName(
          country.alpha2,
          rootState.lang.currentLanguage
        ) || country.name
        return acc
      },
      {}
    )
  },

  countriesWithParcelShopsInDB: (state, getters, rootState) => {
    return countriesWithParcelShopsInDBList.reduce(
      (acc, country) => {
        acc[country.alpha2] = i18nIsoCountriesVar.getName(
          country.alpha2,
          rootState.lang.currentLanguage
        ) || country.name
        return acc
      },
      {}
    )
  },
  
  htmlAttachmentEnabled: state => {
    return state.config.htmlAttachmentEnabled;
  },

  returnReasons: state => {
    return state.returnReasons;
  }
}

const actions = {
  setTexts({state}) {
    if(!state.config.texts) {
      return false
    }

    Object.keys(state.config.texts).forEach(lang => {
      i18next.addResourceBundle(lang, 'translation', state.config.texts[lang], true, true)
    })
  },

  setPortalUuid({ commit, dispatch }, portalUuid) {
    const returnShopPortalConfigUrl = process.env.RETURN_SHOP_PORTAL_CONFIG_URL

    return axios
      .get(`${returnShopPortalConfigUrl}/isrs/v1/c/${portalUuid}`)
      .then(result => {
        commit(SET_CONFIG, result.data.config)
        commit(SET_FEATURES, result.data.features)
        commit(SET_FROM_COUNTRIES, result.data.fromCountries)
        commit(SET_IDENTIFIER, portalUuid)
        commit(SET_RETURN_REASONS, result.data.config.selectedReturnReasons)
        dispatch('setTexts')
      })
  }
}

const mutations = {
  [SET_IDENTIFIER](state, value) {
    state.identifier = value
  },

  [SET_CONFIG](state, value) {
    state.config = value
  },

  [SET_FEATURES](state, value) {
    state.features = value
  },

  [SET_FROM_COUNTRIES](state, value) {
    state.fromCountries = value
  },

  [SET_RETURN_REASONS](state, value) {
    state.returnReasons = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/config/index.js